module.exports = __webpack_public_path__ + "static/media/star.30ea8524.png";